// apiSetup/apiConfig.ts
export const getApiBaseUrl = (): string => {
  // Change this for your real production URL
  if (process.env.NODE_ENV === 'production') {

    return 'https://portal.hciindia.in/api';

  }

  // Local development
  return 'https://portal.hciindia.in/api';


};